export default __webpack_public_path__ + "static/media/subaru.55f6db32.svg";